import { UnaryOperator, DifferenceStreamWriter } from "../graph.js";
import { StreamBuilder } from "../d2.js";
import { MultiSet } from "../multiset.js";
import { TopKState, handleMoveIn, handleMoveOut } from "./topKState.js";
import { createKeyedComparator, TopKArray } from "./topKArray.js";
class TopKWithFractionalIndexOperator extends UnaryOperator {
  #state;
  constructor(id, inputA, output, comparator, options) {
    super(id, inputA, output);
    const limit = options.limit ?? Infinity;
    const offset = options.offset ?? 0;
    const topK = this.createTopK(
      offset,
      limit,
      createKeyedComparator(comparator)
    );
    this.#state = new TopKState(topK);
    options.setSizeCallback?.(() => this.#state.size);
    options.setWindowFn?.(this.moveTopK.bind(this));
  }
  createTopK(offset, limit, comparator) {
    return new TopKArray(offset, limit, comparator);
  }
  /**
   * Moves the topK window based on the provided offset and limit.
   * Any changes to the topK are sent to the output.
   */
  moveTopK({ offset, limit }) {
    const result = [];
    const diff = this.#state.move({ offset, limit });
    diff.moveIns.forEach((moveIn) => handleMoveIn(moveIn, result));
    diff.moveOuts.forEach((moveOut) => handleMoveOut(moveOut, result));
    if (diff.changes) {
      this.output.sendData(new MultiSet(result));
    }
  }
  run() {
    const result = [];
    for (const message of this.inputMessages()) {
      for (const [item, multiplicity] of message.getInner()) {
        const [key, value] = item;
        this.processElement(key, value, multiplicity, result);
      }
    }
    if (result.length > 0) {
      this.output.sendData(new MultiSet(result));
    }
  }
  processElement(key, value, multiplicity, result) {
    const changes = this.#state.processElement(key, value, multiplicity);
    handleMoveIn(changes.moveIn, result);
    handleMoveOut(changes.moveOut, result);
  }
}
function topKWithFractionalIndex(comparator, options) {
  const opts = options || {};
  return (stream) => {
    const output = new StreamBuilder(
      stream.graph,
      new DifferenceStreamWriter()
    );
    const operator = new TopKWithFractionalIndexOperator(
      stream.graph.getNextOperatorId(),
      stream.connectReader(),
      output.writer,
      comparator,
      opts
    );
    stream.graph.addOperator(operator);
    return output;
  };
}
export {
  TopKWithFractionalIndexOperator,
  topKWithFractionalIndex
};
//# sourceMappingURL=topKWithFractionalIndex.js.map
